// English translations for the impression page (French string -> English).
const m: Record<string, string> = {
  // Page chrome
  'Impression': 'Printing',
  'Lots envoyés à l\'imprimeur — quantités, prix, paiements': 'Batches sent to the printer — quantities, prices, payments',
  'Marquer payé ({n}) · {total}': 'Mark as paid ({n}) · {total}',
  // Phone: cards + pinned bar
  'Marquer payé ({n})': 'Mark as paid ({n})',
  '{n} lot(s) · {total}': '{n} batch(es) · {total}',
  'Sélectionner le lot du {date}': 'Select the batch of {date}',

  // À payer counter
  'À payer à l\'imprimeur': 'Owed to the printer',
  '{n} lot en attente · cochez puis « Marquer payé » — un lot ou plusieurs d\'un coup.': '{n} batch pending · tick then "Mark as paid" — one batch or several at once.',
  '{n} lots en attente · cochez puis « Marquer payé » — un lot ou plusieurs d\'un coup.': '{n} batches pending · tick then "Mark as paid" — one batch or several at once.',

  // Batches table
  'Lots d\'impression': 'Print batches',
  'Un lot est créé automatiquement à chaque « Envoyer à l\'imprimeur ». Cliquez un lot pour ajuster les prix.': 'A batch is created automatically each time you "Send to printer". Click a batch to adjust prices.',
  'Lot': 'Batch',
  'Contenu': 'Contents',
  'Prix unitaires': 'Unit prices',
  'Paiement': 'Payment',
  '{c} cmd · {s} feuilles · {v} couv.': '{c} orders · {s} sheets · {v} covers',
  '{s} / feuille · {v} / couv.': '{s} / sheet · {v} / cover',
  'Aucun lot — le premier sera créé automatiquement au prochain « Envoyer à l\'imprimeur » (page Commandes).': 'No batches yet — the first one will be created automatically the next time you "Send to printer" (Orders page).',

  // Payment status pills
  'Payé ✓': 'Paid ✓',
  'À payer': 'To pay',

  // Batch modal
  'Lot du {date}': 'Batch from {date}',
  '{n} commande': '{n} order',
  '{n} commandes': '{n} orders',
  '{n} feuilles A3': '{n} A3 sheets',
  '{n} couverture': '{n} cover',
  '{n} couvertures': '{n} covers',
  'Prix / feuille A3 (MAD)': 'Price / A3 sheet (MAD)',
  'Prix / couverture (MAD)': 'Price / cover (MAD)',
  'Gros lot = prix plus bas — modifiez ici, les coûts par commande se recalculent automatiquement.': 'Larger batch = lower price — edit here and the per-order costs recalculate automatically.',
  '{n} album': '{n} album',
  '{n} albums': '{n} albums',
  '{n} p.': '{n} p.',
  '{n} feuilles + {c} couv.': '{n} sheets + {c} covers',
  'Enregistrer les prix': 'Save prices',
};
export default m;
